import {ProminentBannerSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {CampaignBar, ErrorBoundary, Hint} from '@aboutyou/ui-components';
import React from 'react';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';
import {useIsUrgencyTriggersDisabled} from '../../../shared-deprecated/useIsUrgencyTriggersDisabled';
import {CouponSection} from './Coupons/CouponSection';

export type CouponVariant = 'coupon-slider' | 'coupon-sticky-bar';

export interface ProminentBannerSectionViewProps {
  className?: string;
  style?: React.CSSProperties;
  couponVariant: CouponVariant;
  hideCampaignCountdown?: boolean;
  showLowStockHint?: boolean;
  flatBorders?: boolean;
  selectedSize?: SelectedSize;
  isInMiniADPDialog: boolean;
  removeNegativeMarginTop?: boolean;
  selectedCouponPromotionId?: string;
}

export const ProminentBannerSectionView: React.FC<
  ProminentBannerSection & ProminentBannerSectionViewProps
> = ({
  className,
  style,
  type,
  couponVariant,
  product,
  hideCampaignCountdown: hideCampaignCountdownProp,
  showLowStockHint,
  flatBorders,
  selectedSize,
  isInMiniADPDialog,
  removeNegativeMarginTop,
  selectedCouponPromotionId,
}) => {
  const disableUrgencyTriggers = useIsUrgencyTriggersDisabled();
  const hideCampaignCountdown =
    disableUrgencyTriggers || hideCampaignCountdownProp;

  switch (type?.$case) {
    case 'couponSlider': {
      return (
        <ErrorBoundary
          ErrorComponent={null}
          renderContext="prominent_banner_section_coupon_slider"
        >
          <CouponSection
            className={className}
            style={style}
            couponSlider={type.couponSlider}
            couponVariant={couponVariant}
            productId={product.id}
            flatBorders={flatBorders}
            selectedSize={selectedSize}
            isInMiniADPDialog={isInMiniADPDialog}
            removeNegativeMarginTop={removeNegativeMarginTop}
            selectedCouponPromotionId={selectedCouponPromotionId}
          />
        </ErrorBoundary>
      );
    }
    case 'campaignCountdown': {
      if (hideCampaignCountdown) {
        return null;
      }

      const {backgroundColor, endsAt, textColor} = type.campaignCountdown;

      return (
        <ErrorBoundary
          ErrorComponent={null}
          renderContext="prominent_banner_section_campaign_countdown"
        >
          <CampaignBar
            style={style}
            backgroundColor={backgroundColor}
            endsAt={endsAt}
            textColor={textColor}
          />
        </ErrorBoundary>
      );
    }

    case 'lowStock':
      if (showLowStockHint) {
        return <Hint style={style} label={type.lowStock.label} />;
      }

      return null;
    default:
      return null;
  }
};
